import { useModeStore } from '@/stores/modeStore';

/**
 * Segmented Simulation ↔ Réel switch.
 *
 * The active side occupies EXACTLY half the width and the full height of
 * the container — no padding gap, no visible border. The inactive side
 * is flush against the container, so the two labels look like two
 * adjacent segments with the active one filled in a strong colour
 * (blue · simulation / green · réel).
 */
export function ModeSwitch() {
  const { mode, setMode } = useModeStore();
  const isReal = mode === 'real';

  return (
    <div
      role="switch"
      aria-checked={isReal}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          setMode(isReal ? 'simulation' : 'real');
        }
      }}
      title={isReal ? 'Mode réel — exécution sur Lab cible' : 'Mode simulation — mock SSH local'}
      style={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'stretch',
        height: 32,
        background: 'var(--surface-2)',
        border: 'none',
        borderRadius: 'var(--radius-lg)',
        cursor: 'pointer',
        userSelect: 'none',
        minWidth: 140,
        overflow: 'hidden',
      }}
    >
      {/* Sliding solid block — 50% of the container, full height */}
      <span
        aria-hidden
        style={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: isReal ? '50%' : 0,
          width: '50%',
          background: isReal ? 'var(--success)' : 'var(--info)',
          borderRadius: 'var(--radius-lg)',
          transition:
            'left var(--dur-fast) var(--ease-out), background var(--dur-fast) var(--ease-out)',
          pointerEvents: 'none',
        }}
      />
      {/* Labels */}
      <button
        type="button"
        onClick={() => setMode('simulation')}
        style={{
          position: 'relative',
          flex: 1,
          background: 'transparent',
          border: 'none',
          fontSize: 12,
          fontWeight: 600,
          letterSpacing: '0.02em',
          fontFamily: 'var(--font-sans)',
          color: !isReal ? 'var(--text-on-accent, white)' : 'var(--text-muted)',
          transition: 'color var(--dur-fast) var(--ease-out)',
          cursor: 'pointer',
          padding: 0,
        }}
      >
        simule
      </button>
      <button
        type="button"
        onClick={() => setMode('real')}
        style={{
          position: 'relative',
          flex: 1,
          background: 'transparent',
          border: 'none',
          fontSize: 12,
          fontWeight: 600,
          letterSpacing: '0.02em',
          fontFamily: 'var(--font-sans)',
          color: isReal ? 'var(--success-fg)' : 'var(--text-muted)',
          transition: 'color var(--dur-fast) var(--ease-out)',
          cursor: 'pointer',
          padding: 0,
        }}
      >
        réel
      </button>
    </div>
  );
}
